import { isObjectValid } from "@estaly/ui";

export function formatVariation(variation) {
  return isObjectValid(variation) ? variation : "+ ∞";
}
